import { AccordionSummary, Button, Grid, Input, NativeSelect, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loading from '../../../../components/Loading';
import Header from '../../../../layout/Header';
import Subheader from '../../../../layout/Subheader';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import { handleErrorRequest } from '../../../../utils/errorsValidation';
import { formatDateTimeToRender } from '../../../../utils/functions';
import useStyles from '../style';

export function ExceptionRegister() {
  const classes = useStyles();
  const { id, idExcecao } = useParams();

  const [isLoading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [formValues, setFormValues] = useState({ status: 'Ativo' });
  const [anchors, setAnchors] = useState([]);
  const [providers, setProviders] = useState([]);
  const [provider, setProvider] = useState([]);

  const [getErros, setErros] = useState([]);

  const handleInputChange = (event, value) => {
    event.persist();
    setFormValues((inputs) => ({ ...inputs, [event.target.name]: value || event.target.value }));
  };

  const updateProvider = async (payload) => {
    const payloadUpadte = {
      ...payload,
      fornecedorClassificacaoExcecaoId: Number(idExcecao),
      dataAtualizacao: formValues.dataAtualizacao,
    };
    try {
      const response = await api.put('FornecedoresClassificacoesExcecoes', payloadUpadte);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Classificação exceção do fornecedor alterada com sucesso!');
        setFormValues(response.data.resposta);
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
  };

  const createProvider = async (payload) => {
    try {
      const response = await api.post('FornecedoresClassificacoesExcecoes', payload);
      if (response.data.status !== 'Inconsistencia') {
        toast.success('Classificação exceção do fornecedor criada com sucesso!');
        setFormValues({
          ancoraId: 0,
          classificacaoFornecedorId: 0,
          fornecedorId: 0,
          status: 'Ativo',
        });
      } else {
        setErros(handleErrorRequest(response));
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
  };

  const onSubmit = async () => {
    const payload = {
      ...formValues,
      ...(formValues.ancoraId && { ancoraId: Number(formValues.ancoraId) }),
      ...(id && { fornecedorId: Number(id) }),
    };
    isRegister ? createProvider(payload) : updateProvider(payload);
  };

  const fetchExceptionById = async (id) => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await api.get(`FornecedoresClassificacoesExcecoes/ConsultarId?id=${id}`);
      setFormValues(res.data.resposta);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const fetchAnchors = async () => {
    const res = await api.get('Ancoras/Consultar?status=Ativo');
    setAnchors(res.data.resposta);
  };

  const fetchProviders = async () => {
    const res = await api.get('ClassificacoesFornecedores/Consultar?status=Ativo');
    setProviders(res.data.resposta);
  };

  const fetchProvider = async () => {
    const res = await api.get(`Fornecedores/ConsultarId?id=${id}`);
    setProvider(res.data.resposta);
  };

  useEffect(() => {
    fetchAnchors();
    fetchProviders();
    fetchProvider();
    if (window.location.pathname.includes('cadastrar')) {
      setLoading(false);
      setIsEditing(true);
      setIsRegister(true);
      return;
    }
    if (idExcecao) {
      setIsEditing(window.location.pathname.includes('editar'));
      fetchExceptionById(idExcecao);
    }
  }, [idExcecao]);

  return (
    <div className={classes.root}>
      <Header />
      {isEditing ? (
        <Subheader
          title={`${
            isRegister ? 'Cadastrando' : 'Atualizando'
          } classificação exceção do fornecedor - ${provider?.nomeFantasia}`}
          loading={isLoading}
          submit={onSubmit}
          back={false}
          submitText={`${isRegister ? 'Cadastrar' : 'Atualizar'}`}
        />
      ) : (
        <Subheader
          loading={isLoading}
          back={false}
          title={`Visualizando classificação exceção do fornecedor - ${
            provider?.nomeFantasia ?? ''
          }`}
        />
      )}
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <form onSubmit={onSubmit}>
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                    <Typography className={classes.heading}>Informações</Typography>
                  </AccordionSummary>
                  <AccordionDetails className={classes.details}>
                    <Grid container>
                      <Grid item xs={6}>
                        <label className={classes.label}>Rede</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={handleInputChange}
                            className={classes.input}
                            value={formValues?.ancoraId}
                            name="ancoraId"
                            disabled={!isEditing && !isRegister}
                            onBlur={(event) =>
                              getErros.includes('AncoraId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'AncoraId';
                                }),
                              )
                            }
                            error={getErros.includes('AncoraId')}
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {anchors?.map((anchor) => (
                              <option key={anchor.ancoraId} value={anchor.ancoraId}>
                                {anchor.nomeFantasia}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Status</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            disabled={!isEditing}
                            className={classes.input}
                            value={formValues?.status}
                            name="status"
                            onChange={handleInputChange}
                            onBlur={(event) =>
                              getErros.includes('Status') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'Status';
                                }),
                              )
                            }
                            error={getErros.includes('Status')}
                          >
                            <option value="Ativo">Ativo</option>
                            <option value="Inativo">Inativo</option>
                          </NativeSelect>
                        </Paper>
                      </Grid>

                      <Grid item xs={6}>
                        <label className={classes.label}>Classificação Fornecedor</label>
                        <Paper className={classes.medium} elevation={0}>
                          <NativeSelect
                            onChange={(e) =>
                              setFormValues((prv) => ({
                                ...prv,
                                classificacaoFornecedorId: Number(e.target.value),
                              }))
                            }
                            className={classes.input}
                            value={formValues?.classificacaoFornecedorId}
                            name="classificacaoFornecedorId"
                            disabled={!isEditing && !isRegister}
                            onBlur={(event) =>
                              getErros.includes('ClassificacaoFornecedorId') &&
                              setErros(
                                getErros.filter(function (item) {
                                  return item !== 'ClassificacaoFornecedorId';
                                }),
                              )
                            }
                            error={getErros.includes('ClassificacaoFornecedorId')}
                          >
                            <option value="0">FALTA PREENCHER</option>
                            {providers?.map((provider) => (
                              <option
                                key={provider.classificacaoFornecedorId}
                                value={provider.classificacaoFornecedorId}
                              >
                                {provider.classificacao}
                              </option>
                            ))}
                          </NativeSelect>
                        </Paper>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>

                {!isRegister && (
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={classes.summary}
                    >
                      <Typography className={classes.heading}>Dados do Registro</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.details}>
                      <Grid container>
                        <Grid item xs={6}>
                          <label className={classes.label}>Data de Registro</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataRegistro &&
                                formatDateTimeToRender(formValues.dataRegistro)
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data do Registro"
                            />
                          </Paper>
                        </Grid>

                        <Grid item xs={6}>
                          <label className={classes.label}>Data da Atualização</label>
                          <Paper className={classes.medium} elevation={0}>
                            <Input
                              className={classes.input}
                              value={
                                formValues.dataAtualizacao
                                  ? formatDateTimeToRender(formValues.dataAtualizacao)
                                  : ''
                              }
                              readOnly
                              disabled={!isEditing}
                              placeholder="Data da Atualização"
                            />
                          </Paper>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                )}
                {(isRegister || isEditing) && (
                  <div className={classes.divButton}>
                    <button
                      variant="contained"
                      type="button"
                      onClick={onSubmit}
                      className={classes.button}
                    >
                      {isRegister ? 'Cadastrar' : 'Atualizar'}
                    </button>
                  </div>
                )}
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
